/**
 * @internal
 */
export const RuleConstants = {
    Keys: {
        None: 'none',
    },
};
